import RonikiImg from "../../assets/Roniki.jpg";
import NivashImg from "../../assets/Nivash.jpg";
import ShikharImg from "../../assets/Shikhar.jpg";
import SidhiImg from "../../assets/Sidhi.jpg";
import VikrantImg from "../../assets/Vikrant.jpg";
import AkshayImg from "../../assets/Akshay.jpg";
import VikashIng from "../../assets/Vikash.jpg";

export const PhDScholars = [
  { degree: "Ph.D Scholars" },
  {
    image: RonikiImg,
    name: "Roniki Anjaneyulu",
    topic:
      "Terrestrial and groundwater storage analysis, flood analysis, and dam break analysis",
  },
  {
    image: SidhiImg,
    name: "Siddhi Chahaun",
    topic: "Impact of climate change on surface water bodies",
  },
  {
    image: VikrantImg,
    name: "Vikrant Shisodia",
    topic: "Anthropogenic and climate change impact at catchment scale",
  },
  {
    image: AkshayImg,
    name: "Akshay Lingwal",
    topic: "Ground water modelling and climate change",
  },
  {
    image: VikashIng,
    name: "Vikas Singh Jadoun",
    topic: "Research area - Glacial lake outburst floods",
  },
];

export const Masters = [
  { degree: "Masters" },
  {
    image: NivashImg,
    name: "Nivesh Sakharwade",
    topic: "Flood risk assessment using machine learning",
  },
  {
    image: ShikharImg,
    name: "Shikhar verma",
    topic: "Reservoir outflow prediction using machine learning algorithm",
  },
];
